// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter
import { ThemeProvider } from './ThemeContext'; // Import ThemeProvider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider> {/* Wrap with ThemeProvider */}
      <Router> {/* Wrap App in Router */}
        <App />
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);
